import { render } from "./MillToFactoryDispatch.vue?vue&type=template&id=0406f0aa&scoped=true"
import script from "./MillToFactoryDispatch.vue?vue&type=script&lang=js"
export * from "./MillToFactoryDispatch.vue?vue&type=script&lang=js"

import "./MillToFactoryDispatch.vue?vue&type=style&index=0&id=0406f0aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0406f0aa"]])

export default __exports__